import { useEffect, useState, useRef } from "react";
import {
  Grid,
  Typography,
  Button,
  Dialog,
  DialogContent,
  DialogActions,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import formatDate from "../../../utilities/formatDate";

import EmailEditor from "react-email-editor";
import request from "../../../utilities/requests";
import { toast } from "../../../utilities/SnackBarUtils";

const TandC = () => {
  const editorRef = useRef(null);
  const [terms, setTerms] = useState(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    getTerms();
  }, []);

  useEffect(() => {
    if (terms && editorRef.current?.editor) {
      editorRef.current.editor.loadDesign(terms.jsonBody);
    }
  }, [terms]);

  const getTerms = async () => {
    const result = await request("systemmessage/terms/?edit=true");
    if (result.success) {
      setTerms(result.data);
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSave = async (data) => {
    const unlayer = editorRef.current?.editor;

    if (unlayer) {
      unlayer.exportHtml(async function (d) {
        const data = {
          htmlBody: d.html,
          jsonBody: d.design,
        };
        const result = await request(
          `systemmessage/terms/update`,
          "post",
          data
        );

        if (result.success) {
          setTerms(result.data);
          toast.success("Success!");
          handleClose();
        } else {
          toast.error(result.error);
        }
      });
    } else {
      console.warn("Unlayer editor not ready");
    }
  };

  return (
    <Grid container>
      <Grid
        item
        xs={12}
        style={{ display: "flex", gap: 20, alignItems: "center" }}
      >
        <Typography>Version: {terms?.version}</Typography>
        <Button variant="outlined" onClick={() => setOpen(true)}>
          Save
        </Button>
      </Grid>
      <Grid item xs={12}>
        <EmailEditor ref={editorRef} style={{ height: 700 }} />
      </Grid>
      <Dialog open={open} onClose={handleClose}>
        <DialogContent>
          <Typography>Saving will create a new version. Still save?</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleSave}>Save</Button>
        </DialogActions>
      </Dialog>
    </Grid>
  );
};

export default TandC;
